// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.webhook-result-modal {
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 900px;
    width: 90%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 2px solid #f0f0f0;
    background: white;
    color: #333;
    border-radius: 16px 16px 0 0;
}

.modal-header h2 {
    margin: 0 0 8px 0;
    font-size: 24px;
    font-weight: 600;
}

.test-type-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
}

.test-type-badge.ok {
    background: rgba(46, 213, 115, 0.2);
}

.test-type-badge.nok {
    background: rgba(255, 159, 67, 0.2);
}

.close-btn {
    background: #f0f0f0;
    border: none;
    color: #333;
    font-size: 32px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    line-height: 1;
    padding: 0;
}

.close-btn:hover {
    background: #e0e0e0;
    transform: rotate(90deg);
}

.modal-body {
    padding: 24px 32px;
    overflow-y: auto;
    flex: 1 1;
}

.result-section {
    margin-bottom: 24px;
    background: #f8f9fa;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: white;
    border-bottom: 1px solid #e9ecef;
}

.section-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 8px;
}

.icon {
    font-size: 20px;
}

.section-content {
    padding: 20px;
}

.section-content .copy-btn {
    display: block;
    margin-bottom: 12px;
}

.info-grid {
    display: grid;
    gap: 16px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.info-item label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: #6c757d;
    letter-spacing: 0.5px;
}

.info-value {
    display: flex;
    align-items: center;
    gap: 8px;
}

.url-value {
    background: white;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    word-break: break-all;
    width: 100%;
    margin-bottom: 8px;
}

.url-value code {
    color: #333;
}

.status-badge {
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-badge.success {
    background: #d4edda;
    color: #155724;
}

.status-badge.error {
    background: #f8d7da;
    color: #721c24;
}

.status-badge.warning {
    background: #fff3cd;
    color: #856404;
}

.status-code {
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 14px;
}

.status-code.success {
    background: #d4edda;
    color: #155724;
}

.status-code.error {
    background: #f8d7da;
    color: #721c24;
}

.status-code.warning {
    background: #fff3cd;
    color: #856404;
}

.duration {
    font-weight: 600;
    font-size: 14px;
    color: #495057;
}

.duration-indicator {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 10px;
    margin-left: 8px;
    font-weight: 600;
}

.duration-indicator.fast {
    background: #d4edda;
    color: #155724;
}

.duration-indicator.moderate {
    background: #fff3cd;
    color: #856404;
}

.duration-indicator.slow {
    background: #f8d7da;
    color: #721c24;
}

.error-section {
    border-color: #f8d7da;
    background: #fff5f5;
}

.error-box {
    background: white;
    padding: 16px;
    border-radius: 8px;
    border-left: 4px solid #dc3545;
}

.error-title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: #721c24;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
}

.error-message {
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    color: #721c24;
    margin-bottom: 8px;
    line-height: 1.6;
}

.error-code {
    font-size: 12px;
    color: #6c757d;
    font-family: 'Monaco', 'Courier New', monospace;
}

.code-block {
    background: #282c34;
    border-radius: 8px;
    padding: 16px;
    overflow-x: auto;
    border: 1px solid #1a1d23;
}

.code-block pre {
    margin: 0;
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.6;
    color: #abb2bf;
    white-space: pre;
    overflow-x: auto;
}

.copy-btn {
    background: transparent;
    color: #555;
    border: 1px solid #ccc;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    flex-shrink: 0;
}

.copy-btn:hover {
    border-color: #999;
    background: #f5f5f5;
    transform: translateY(-1px);
}

.copy-btn:active {
    transform: translateY(0);
}

.copy-btn-small {
    background: transparent;
    color: #555;
    border: 1px solid #ccc;
    padding: 4px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 600;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    flex-shrink: 0;
}

.copy-btn-small:hover {
    border-color: #999;
    background: #f5f5f5;
}

.copy-btn-small:active {
    transform: translateY(0);
}

.modal-footer {
    padding: 20px 32px;
    border-top: 2px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
    border-radius: 0 0 16px 16px;
}

.primary-btn {
    background: #555;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s;
    min-width: auto;
    flex-shrink: 0;
}

.primary-btn:hover {
    background: #666;
    transform: translateY(-1px);
}

.primary-btn:active {
    transform: translateY(0);
}

/* Scrollbar styling */
.modal-body::-webkit-scrollbar {
    width: 8px;
}

.modal-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.modal-body::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 10px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
    background: #777;
}

.code-block::-webkit-scrollbar {
    height: 6px;
}

.code-block::-webkit-scrollbar-track {
    background: #1a1d23;
}

.code-block::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 10px;
}

/* Responsive */
@media (max-width: 768px) {
    .webhook-result-modal {
        width: 95%;
        max-height: 95vh;
    }

    .modal-header,
    .modal-body,
    .modal-footer {
        padding: 16px 20px;
    }

    .modal-header h2 {
        font-size: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebhookTestResultModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,+CAA+C;IAC/C,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;;;QAGI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.webhook-result-modal {\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    max-width: 900px;\n    width: 90%;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 32px;\n    border-bottom: 2px solid #f0f0f0;\n    background: white;\n    color: #333;\n    border-radius: 16px 16px 0 0;\n}\n\n.modal-header h2 {\n    margin: 0 0 8px 0;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.test-type-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n}\n\n.test-type-badge.ok {\n    background: rgba(46, 213, 115, 0.2);\n}\n\n.test-type-badge.nok {\n    background: rgba(255, 159, 67, 0.2);\n}\n\n.close-btn {\n    background: #f0f0f0;\n    border: none;\n    color: #333;\n    font-size: 32px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n    line-height: 1;\n    padding: 0;\n}\n\n.close-btn:hover {\n    background: #e0e0e0;\n    transform: rotate(90deg);\n}\n\n.modal-body {\n    padding: 24px 32px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.result-section {\n    margin-bottom: 24px;\n    background: #f8f9fa;\n    border-radius: 12px;\n    overflow: hidden;\n    border: 1px solid #e9ecef;\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    background: white;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.section-header h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #2c3e50;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.icon {\n    font-size: 20px;\n}\n\n.section-content {\n    padding: 20px;\n}\n\n.section-content .copy-btn {\n    display: block;\n    margin-bottom: 12px;\n}\n\n.info-grid {\n    display: grid;\n    gap: 16px;\n}\n\n.info-item {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.info-item label {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #6c757d;\n    letter-spacing: 0.5px;\n}\n\n.info-value {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.url-value {\n    background: white;\n    padding: 12px;\n    border-radius: 8px;\n    border: 1px solid #dee2e6;\n    font-family: 'Monaco', 'Courier New', monospace;\n    font-size: 13px;\n    word-break: break-all;\n    width: 100%;\n    margin-bottom: 8px;\n}\n\n.url-value code {\n    color: #333;\n}\n\n.status-badge {\n    padding: 6px 16px;\n    border-radius: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.status-badge.success {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status-badge.error {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.status-badge.warning {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.status-code {\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-weight: 600;\n    font-family: 'Monaco', 'Courier New', monospace;\n    font-size: 14px;\n}\n\n.status-code.success {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status-code.error {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.status-code.warning {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.duration {\n    font-weight: 600;\n    font-size: 14px;\n    color: #495057;\n}\n\n.duration-indicator {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 10px;\n    margin-left: 8px;\n    font-weight: 600;\n}\n\n.duration-indicator.fast {\n    background: #d4edda;\n    color: #155724;\n}\n\n.duration-indicator.moderate {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.duration-indicator.slow {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.error-section {\n    border-color: #f8d7da;\n    background: #fff5f5;\n}\n\n.error-box {\n    background: white;\n    padding: 16px;\n    border-radius: 8px;\n    border-left: 4px solid #dc3545;\n}\n\n.error-title {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: #721c24;\n    margin-bottom: 8px;\n    letter-spacing: 0.5px;\n}\n\n.error-message {\n    font-family: 'Monaco', 'Courier New', monospace;\n    font-size: 13px;\n    color: #721c24;\n    margin-bottom: 8px;\n    line-height: 1.6;\n}\n\n.error-code {\n    font-size: 12px;\n    color: #6c757d;\n    font-family: 'Monaco', 'Courier New', monospace;\n}\n\n.code-block {\n    background: #282c34;\n    border-radius: 8px;\n    padding: 16px;\n    overflow-x: auto;\n    border: 1px solid #1a1d23;\n}\n\n.code-block pre {\n    margin: 0;\n    font-family: 'Monaco', 'Courier New', monospace;\n    font-size: 13px;\n    line-height: 1.6;\n    color: #abb2bf;\n    white-space: pre;\n    overflow-x: auto;\n}\n\n.copy-btn {\n    background: transparent;\n    color: #555;\n    border: 1px solid #ccc;\n    padding: 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    transition: all 0.2s;\n    white-space: nowrap;\n    min-width: auto;\n    flex-shrink: 0;\n}\n\n.copy-btn:hover {\n    border-color: #999;\n    background: #f5f5f5;\n    transform: translateY(-1px);\n}\n\n.copy-btn:active {\n    transform: translateY(0);\n}\n\n.copy-btn-small {\n    background: transparent;\n    color: #555;\n    border: 1px solid #ccc;\n    padding: 4px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 600;\n    transition: all 0.2s;\n    white-space: nowrap;\n    min-width: auto;\n    flex-shrink: 0;\n}\n\n.copy-btn-small:hover {\n    border-color: #999;\n    background: #f5f5f5;\n}\n\n.copy-btn-small:active {\n    transform: translateY(0);\n}\n\n.modal-footer {\n    padding: 20px 32px;\n    border-top: 2px solid #f0f0f0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    background: #f8f9fa;\n    border-radius: 0 0 16px 16px;\n}\n\n.primary-btn {\n    background: #555;\n    color: white;\n    border: none;\n    padding: 10px 24px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    transition: all 0.2s;\n    min-width: auto;\n    flex-shrink: 0;\n}\n\n.primary-btn:hover {\n    background: #666;\n    transform: translateY(-1px);\n}\n\n.primary-btn:active {\n    transform: translateY(0);\n}\n\n/* Scrollbar styling */\n.modal-body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.modal-body::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n}\n\n.modal-body::-webkit-scrollbar-thumb {\n    background: #999;\n    border-radius: 10px;\n}\n\n.modal-body::-webkit-scrollbar-thumb:hover {\n    background: #777;\n}\n\n.code-block::-webkit-scrollbar {\n    height: 6px;\n}\n\n.code-block::-webkit-scrollbar-track {\n    background: #1a1d23;\n}\n\n.code-block::-webkit-scrollbar-thumb {\n    background: #999;\n    border-radius: 10px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .webhook-result-modal {\n        width: 95%;\n        max-height: 95vh;\n    }\n\n    .modal-header,\n    .modal-body,\n    .modal-footer {\n        padding: 16px 20px;\n    }\n\n    .modal-header h2 {\n        font-size: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
